"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const feed_v2_models_1 = require("@forto-dev/feed-v2-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const BookingUpdateActivity_1 = require("./BookingUpdateActivity");
const CustomsDecisionActivity_1 = require("./CustomsDecisionActivity");
const DocumentUploadActivity_1 = require("./DocumentUploadActivity");
const ManualQuoteActivity_1 = require("./ManualQuoteActivity");
const MessageActivity_1 = require("./MessageActivity");
const RateUpdateAppliedActivity_1 = require("./RateUpdateAppliedActivity");
const ShipmentUpdateActivity_1 = require("./ShipmentUpdateActivity");
const SubscriptionActivity_1 = require("./SubscriptionActivity");
const TransportPlanUpdatedActivity_1 = require("./TransportPlanUpdatedActivity");
const ActivityContent = ({ feed, isForCustomer }) => {
    const { activity, feedInfo } = feed;
    const feedV1Activity = activity?.customField?.['feedV1Activity'];
    const getActivityContent = () => {
        if (feedV1Activity) {
            if (activity.type === feed_v2_models_1.ActivityType.MessageFeedV1 || activity.type === feed_v2_models_1.ActivityType.CommunicationFeedV1) {
                return (0, jsx_runtime_1.jsx)(MessageActivity_1.MessageActivity, { activity: feedV1Activity });
            }
            if (activity.type === feed_v2_models_1.ActivityType.DocumentUploadFeedV1) {
                return (0, jsx_runtime_1.jsx)(DocumentUploadActivity_1.DocumentUploadActivity, { activity: feedV1Activity, shipmentId: feedInfo.entityID });
            }
            if (activity.type === feed_v2_models_1.ActivityType.ShipmentUpdateFeedV1) {
                return (0, jsx_runtime_1.jsx)(ShipmentUpdateActivity_1.ShipmentUpdateActivity, { activity: feedV1Activity });
            }
            if (activity.type === feed_v2_models_1.ActivityType.CustomsDecisionUpdateFeedV1) {
                return (0, jsx_runtime_1.jsx)(CustomsDecisionActivity_1.CustomsDecisionActivity, { activity: feedV1Activity });
            }
            if (activity.type === feed_v2_models_1.ActivityType.BookingUpdateFeedV1) {
                return (0, jsx_runtime_1.jsx)(BookingUpdateActivity_1.BookingUpdateActivity, { activity: feedV1Activity });
            }
            if (activity.type === feed_v2_models_1.ActivityType.RateUpdateAppliedFeedV1) {
                return (0, jsx_runtime_1.jsx)(RateUpdateAppliedActivity_1.RateUpdateAppliedActivity, { activity: feedV1Activity });
            }
            if (activity.type === feed_v2_models_1.ActivityType.ManualQuoteFeedV1 || activity.type === feed_v2_models_1.ActivityType.ManualQuoteDeclineFeedV1) {
                const { status, declineReasons, declineCustomReason } = feedV1Activity;
                if (status !== 'pending' &&
                    (declineReasons == null || declineReasons.length === 0) &&
                    declineCustomReason == null) {
                    return null;
                }
                return (0, jsx_runtime_1.jsx)(ManualQuoteActivity_1.ManualQuoteActivity, { activity: feedV1Activity });
            }
            return null;
        }
        if (activity.type === feed_v2_models_1.ActivityType.UpdateShipment) {
            return (0, jsx_runtime_1.jsx)(ShipmentUpdateActivity_1.ShipmentUpdateActivity, { activity: activity?.customField });
        }
        if ([
            feed_v2_models_1.ActivityType.ChangeCargoReadyDate,
            feed_v2_models_1.ActivityType.ChangeCargoReadyDateAggregation,
            feed_v2_models_1.ActivityType.ChangePickup,
            feed_v2_models_1.ActivityType.ChangePickupAggregation,
            feed_v2_models_1.ActivityType.ChangeEstimatedTimeDeparture,
            feed_v2_models_1.ActivityType.ChangeEstimatedTimeDepartureAggregation,
            feed_v2_models_1.ActivityType.ChangeArrival,
            feed_v2_models_1.ActivityType.ChangeArrivalAggregation,
            feed_v2_models_1.ActivityType.ChangeDelivery,
            feed_v2_models_1.ActivityType.ChangeDeliveryAggregation,
        ].includes(activity.type)) {
            return (0, jsx_runtime_1.jsx)(TransportPlanUpdatedActivity_1.TransportPlanUpdatedActivity, { feed: feed });
        }
        if (!isForCustomer &&
            [feed_v2_models_1.ActivityType.SubscriptionAddFeedV1, feed_v2_models_1.ActivityType.SubscriptionRemoveFeedV1].includes(activity.type) &&
            feed?.activity?.customField?.['reason'] != null) {
            return (0, jsx_runtime_1.jsx)(SubscriptionActivity_1.SubscriptionActivity, { feed: feed });
        }
        return null;
    };
    const activityContent = getActivityContent();
    return activityContent ? ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { p: 1.5, pt: 0, children: activityContent })) : null;
};
exports.ActivityContent = ActivityContent;
//# sourceMappingURL=ActivityContent.js.map